import React, { forwardRef } from "react";
import { IconWrapperProps } from "./IconWrapper.types";
import { StyledIconWrapper } from "./IconWrapper.styles";

const IconWrapper = forwardRef<HTMLDivElement, IconWrapperProps>(
    (props: IconWrapperProps, ref) => {
        const {
            children,
            id,
            title,
            height,
            width,
            onClick,
            svgFillColor,
            strokeColor,
            gap,
            rotate,
        } = props;

        return (
            <StyledIconWrapper
                title={title}
                id={id}
                height={height}
                width={width}
                onClick={onClick}
                svgFillColor={svgFillColor}
                gap={gap}
                rotate={rotate}
                strokeColor={strokeColor}
            >
                {children}
            </StyledIconWrapper>
        );
    },
);

export default IconWrapper;
